// extracted by mini-css-extract-plugin
export default {"button":"Uk-z","reviewSort":"Vk-z"};